<template>
  <div class="filtro">
    <el-button :class="classe" plain @click="$emit('clickButton')">
      {{ name }} <i class="el-icon-arrow-down"></i>
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'Filtro',
  props: {
    name: {
      type: String
    },
    classe: {
      type: String
    }
  }
}
</script>
